import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Card, Button, CardActionArea, CardHeader, DialogTitle, Avatar, Stack, Typography } from '@mui/material';
import RocketRoundedIcon from '@mui/icons-material/RocketRounded';
import { useSelector } from 'react-redux';
import { useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import graph from './graph';
import { isEmptyObject } from 'helpers/formatObject';
import { digitsEnToFa } from '@persian-tools/persian-tools';

export default function ChangePaymentType({ title, model, refetch }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { userToken } = useSelector((state) => state.auth);

  const {
    id,
    call_me,
    fast_send,
    total_cost,
    created_at,
    demand_time,
    delivery_time,
    tracking_code,
    shop,
    status,
    customer,
    shipping,
    payment_type,
  } = model;

  const { data, loading } = useQuery(graph.paymentType.query, {
    variables: {
      shop_ids: shop?.id,
    },
    context: {
      serviceName: graph.paymentType.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const paymentTypes = !isEmptyObject(data) ? data[graph.paymentType.name]?.data : [];

  const [formUpdate] = useMutation(graph.changePayment.query, {
    context: {
      serviceName: graph.changePayment.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const handleChange = async (payment_type_id) => {
    try {
      const { data } = await formUpdate({
        variables: {
          ids: id,
          payment_type_id,
        },
      });
      if (data) {
        const res = data[graph.changePayment.name];
        res.messages.map((message) => toast.success(String(message)));
        refetch();
        handleClose();
      }
    } catch (error) {}
  };

  return (
    <>
      <Button
        size="small"
        color="warning"
        onClick={handleOpen}
        sx={{ bgcolor: 'warning.lighter', color: 'warning.dark', minWidth: 96 }}
      >
        {title}
      </Button>
      <Dialog
        dir="rtl"
        fullWidth
        open={open}
        maxWidth="xs"
        PaperComponent={Box}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minHeight: '30%',
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ px: 1 }} component="div">
          <Typography variant="subtitle1" color="#fff">
            انتخاب روش پرداخت
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 1 }}>
          <Stack rowGap={1}>
            {paymentTypes.map((item, i) => {
              const disabled = payment_type?.id == item.id;
              return (
                <Card key={i} sx={{ bgcolor: disabled && 'warning.lighter' }}>
                  <CardActionArea disabled={disabled} onClick={() => handleChange(item.id)}>
                    <CardHeader
                      title={item.title}
                      avatar={
                        <Avatar sx={{ bgcolor: 'info.lighter' }}>
                          <RocketRoundedIcon color="info" fontSize="small" />
                        </Avatar>
                      }
                    />
                  </CardActionArea>
                </Card>
              );
            })}
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
